import { render, staticRenderFns } from "./PaymentOtcSuccess.vue?vue&type=template&id=3e6bb0c2&"
import script from "./PaymentOtcSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentOtcSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports